/**
 * 設定ファイルロードサービス
 * サーバ環境では /common/js/settings.json から読み込み
 * 開発環境でテストする場合は、dev_simulation/public/config/settings.json をサーバの /common/js/settings.json と同じ場所に配置
 */

/**
 * サーバ設定を非同期で読み込む
 * @param {string} configPath - 設定ファイルのパス（デフォルト: /common/js/settings.json）
 * @returns {Promise<Object|null>} - 読み込んだ設定オブジェクト、失敗時はnull
 */
export const loadServerConfig = async (configPath = '/common/js/settings.json') => {
  try {
    const response = await fetch(configPath);
    if (!response.ok) {
      throw new Error();
    }
    return await response.json();
  } catch (error) {
    console.warn('デフォルト設定を使用します。設定ファイルが見つかりません。');
    return null;
  }
};
